module.exports = __webpack_public_path__ + "static/media/Portrait-10233.ff118334.jpg";